<template>
    <section>
        <a v-on:click="processTimings()">Timings</a>
        <!-- Modal -->
        <div class="modal fade" id="branchTimingModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" id="myModalLabel">Timings</h4>
                    </div>
                    <div class="modal-body">
                        <table class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Day</th><th>Open</th><th>Close</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(timing,index) in timingObject" v-bind:class="(timing.today) ? 'success' : ''" v-bind:key="'bt_' + index">
                                    <td>{{timing.day}}</td>
                                    <td>{{timing.niceStartTime}}</td>
                                    <td>{{timing.niceEndTime}}</td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    /* eslint-disable */
    export default {
        name: "BranchTimings",
        data() {
            return {
                timingObject: []
            }
        },
        props:["timings"],
        methods:{
            processTimings: function (){
                this.timingObject = JSON.parse(this.timings);
                let toDate = new Date();
                let days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
                let toDay = days[new Date().getDay()];
                for (let t = 0; t < this.timingObject.length; t++){

                    (typeof this.timingObject[t].starting === "number") && ( this.timingObject[t].starting = ('0'+this.timingObject[t].starting).slice(-2)+':00' );
                    (typeof this.timingObject[t].closing === "number") && ( this.timingObject[t].closing = ('0'+this.timingObject[t].closing).slice(-2)+':00' );

                    let openTime = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), parseInt(this.timingObject[t].starting.split(":")[0]), parseInt(this.timingObject[t].starting.split(":")[1]));
                    let closingTime = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), parseInt(this.timingObject[t].closing.split(":")[0]), parseInt(this.timingObject[t].closing.split(":")[1]));
                    if(this.timingObject[t].closesOnNextDay){
                        closingTime.setDate(closingTime.getDate()+1);
                    }
                    this.timingObject[t].niceStartTime = this.$moment(openTime).local().format('hh:mm A');
                    this.timingObject[t].niceEndTime = this.$moment(closingTime).local().format('hh:mm A');
                    this.timingObject[t].today = this.timingObject[t].day.toLowerCase() === toDay.toLowerCase();
                }
                $("#branchTimingModal").modal("show");
            }
        }
    }
</script>

<style scoped>

</style>